import { Flex, styled } from '@project44/manifest-ds';

export const CustomButtonGroup = styled(Flex, {
  flexDirection: 'column',
  boxShadow: '$small',
  borderRadius: '$small',
  background: '$background-surface',
  button: {
    boxShadow: 'none',
    '&:first-child': {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    },
    '&:last-child': {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
    },
  },
});
